'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationExtraServicesGroupController = function () {
    function WinresReservationExtraServicesGroupController($rootScope, $scope, $timeout, $filter) {
        _classCallCheck(this, WinresReservationExtraServicesGroupController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
    }

    _createClass(WinresReservationExtraServicesGroupController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-extra-services-group]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();
            if (this.group.GroupType === 'GroupForced') {
                this.splitPassengerAndBookingItemsToGroups();
                this.watchSelectedAmounts();
            }

            // Main product was added to cart while forced extra services were still loading.
            if (this.addForcedDelay === true) {
                this.findMainProduct();

                // Check if cart still has the main product.
                if (this.group.hasMainProduct === true) {
                    this.addForcedItemsToCart();
                }

                this.addForcedDelay = false;
            }

            if (this.group.GroupType === 'SimpleForced' || this.group.GroupType === 'GroupForced') {
                this.$scope.$on('add-forced-extra-services-to-cart', function () {
                    return _this.addForcedItemsToCart();
                });
            } else if (this.group.GroupType === 'Normal') {
                this.$scope.$on('remove-products-from-cart', function (event, products) {
                    return _this.removeProductsFromCart(products);
                });
            }

            this.validate();

            // Watch products for accommodation.
            this.$scope.$watch('$ctrl.data.Products', function () {
                _this.findMainProduct();
                _this.validate();
            }, true);
        }
    }, {
        key: 'findMainProduct',
        value: function findMainProduct() {
            var _this2 = this;

            var mainProduct = _.find(this.data.Products, function (productLine) {
                return _this2.data.Destination.DestinationCode === productLine.Product.DestinationInfo.DestinationCode && _this2.data.DefaultStartDate === productLine.Product.BeginDate && _this2.data.DefaultEndDate === productLine.Product.EndDate;
            });

            this.group.hasMainProduct = mainProduct !== undefined;
            this.group.mainProduct = mainProduct;
        }
    }, {
        key: 'addForcedItemsToCart',
        value: function addForcedItemsToCart() {
            var _this3 = this;

            // Simple forced items
            if (this.group.GroupType === 'SimpleForced') _.each(this.group.Items, function (item) {
                return _this3.addItem(item);
            });

            // Selected group forced item.
            if (this.group.GroupType === 'GroupForced') {
                // Selected passenger group extra services.
                _.each(this.group.Items, function (item) {
                    if (item.ForcingMultiplier === 'PerPassenger' && item.SelectedAmount > 0) {
                        _this3.addItem(item);
                    }
                });

                // Selected booking group extra service.
                if (this.group.selectedItem) {
                    this.addItem(this.group.selectedItem);
                }

                // this.editable = true;
                // this.editWatchers = [];
                // _.each(this.group.Items, item=>{
                //     this.editWatchers.push(this.$scope.$watch(() => item, () => {
                //         if(item.SelectedAmount>0 && this.passengerAmount<=this.getNumOfPeople())
                //             this.addItem(item);
                //         if(item.SelectedAmount===0)
                //             this.data.Products = _.filter(this.data.Products, product => { 
                //                 var a = product.Product.DestinationInfo.ProductCode !== item.ProdCode && product.PriceLabel !== item.SelectedPrice.Label;
                //                 return !a;
                //             })
                //     }, true));
                // });

                // this.editWatchers.push(this.$scope.$watch('$ctrl.group.selectedItem', () => {
                //     if(this.group.selectedItem)
                //        this.addItem(this.group.selectedItem);
                // }, true));
            }
        }

        // removeForcedItemsFromCart(){
        //     // Clear all watchers.
        //     _.each(this.editWatchers, watch=>watch());
        //     this.editWatchers = [];
        //     this.editable = false;
        // }

    }, {
        key: 'removeProductsFromCart',
        value: function removeProductsFromCart(products) {
            var _this4 = this;

            // Resed used free places.
            _.each(products, function (productLine) {
                _.each(_this4.group.Items, function (item) {
                    if (item.StartDate === productLine.Product.BeginDate && item.EndDate === productLine.Product.EndDate && item.DestCode === productLine.Product.DestinationInfo.DestinationCode && item.ProdCode === productLine.Product.DestinationInfo.ProductCode) item.UsedFreePlaces = 0;
                });
            });
        }
    }, {
        key: 'watchSelectedAmounts',
        value: function watchSelectedAmounts() {
            var _this5 = this;

            this.passengerAmount = 0;
            var items = _.filter(this.group.Items, function (item) {
                return item.ForcingMultiplier === 'PerPassenger';
            });
            _.each(items, function (item) {
                // Passenger amounts.
                _this5.$scope.$watch(function () {
                    return item.SelectedAmount;
                }, function () {
                    _this5.passengerAmount = _.sumBy(items, function (item) {
                        return item.SelectedAmount;
                    });
                    _this5.updatePassengerAmountTitle();
                });
            });
        }
    }, {
        key: 'splitPassengerAndBookingItemsToGroups',
        value: function splitPassengerAndBookingItemsToGroups() {
            this.bookingGroupItems = _.filter(this.group.Items, function (item) {
                return item.ForcingMultiplier === 'PerBooking';
            });
            this.passengerGroupItems = _.filter(this.group.Items, function (item) {
                return item.ForcingMultiplier === 'PerPassenger';
            });
        }
    }, {
        key: 'getParent',
        value: function getParent() {
            if (this.searchProduct !== undefined) {
                // Find correct productline in cart.
                // Can't use searchProduct as Parent because BeginDate and EndDate are 0001-01-01.
                var line = this.winresReservationContext.findProductLineByProduct(this.searchProduct, true); // ignoreDates

                return {
                    DestCode: line.Product.DestinationInfo.DestinationCode,
                    ProdCode: line.Product.DestinationInfo.ProductCode,
                    BeginDate: line.Product.BeginDate,
                    EndDate: line.Product.EndDate
                };
            }
            return null;
        }
    }, {
        key: 'addItem',
        value: function addItem(item) {
            if (this.group.GroupType === 'Normal' && !this.group.hasMainProduct) {
                // Prevent adding products with Normal group type and if no main product.
                return;
            }

            if (item.LinkingInfo.Type === 'Day') {
                // Add product per day.
                this.addDayProducts(item);
                return;
            }

            // Add single product.
            this.addProduct(item);
        }
    }, {
        key: 'addDayProducts',
        value: function addDayProducts(item) {
            // Day difference + first day.
            var days = moment(item.EndDate).diff(moment(item.StartDate), 'days') + 1;

            var i = 0;

            // Add product per day.
            for (i = 0; i < days; i++) {
                var dayItem = _.cloneDeep(item);

                dayItem.StartDate = moment(item.StartDate).add(i, 'days').format('YYYY-MM-DD');
                dayItem.EndDate = moment(item.StartDate).add(i + 1, 'days').format('YYYY-MM-DD');

                // Use original price for each product.
                dayItem.SelectedPrice.Price /= days;

                if (dayItem.LinkingInfo.IsForEachPassenger) {
                    dayItem.SelectedPrice.Price /= item.SelectedAmount;
                }

                this.addProduct(dayItem);
            }
        }
    }, {
        key: 'addProduct',
        value: function addProduct(item) {
            // Create product from item.
            var product = {
                Price: String(item.SelectedPrice.Price),
                PriceLabel: item.SelectedPrice.Label,
                DestinationCode: item.DestCode,
                ReservablePrices: [],
                BeginDate: item.StartDate,
                EndDate: item.EndDate,
                //TaxPros: '?',
                DestinationInfo: {
                    ProductName: item.Name,
                    ProductCode: item.ProdCode,
                    DestinationCode: item.DestCode
                }
            };

            product.ReservablePrices.push(item.Price);

            product.LinkingInfo = {
                ForcingMode: this.group.GroupType === 'Normal' ? 'Normal' : 'Forced',
                GroupID: item.SelectedPrice.Index,
                Type: item.LinkingInfo && item.LinkingInfo.Type
            };

            // if(this.editable && item.ForcingMultiplier === 'PerBooking'){
            //     this.data.Products = _.filter(this.data.Products, productLine => productLine.GroupId !== this.group.GroupId && productLine.ForcingMultiplier !== 'PerBooking');
            // }

            // Get productLine. Create productLine if price label was not found.
            var productLine = this.findOrCreateProductLineByProductAndByPriceLabel(product);
            if (!productLine) {
                item.UsedFreePlaces = 0;
            }

            // Edit message.
            // if(this.editable && productSearch.hadProductLine)
            //     this.popup(this.$filter('i18next')('reservation_extra_services.test', {
            //         test: item.Name 
            //     }));

            // Add amount and prices.
            if (productLine) {
                this.modifyProductLine(item, productLine);
            }
        }
    }, {
        key: 'modifyProductLine',
        value: function modifyProductLine(item, productLine) {
            // Add amount if normal product.
            var product = this.findNormalProductLineInGroup(productLine);

            // Day link type.
            if (item.LinkingInfo.Type === 'Day') {
                // Use fixed amount for day link type.
                productLine.Amount = item.SelectedAmount;
            } else if (product) {
                product.Amount += item.SelectedAmount;
                productLine.Amount = product.Amount;
            } else {
                productLine.Amount = item.SelectedAmount;
            }

            if (this.group.GroupType === 'Normal') {
                item.UsedFreePlaces += item.SelectedAmount;
            }

            productLine.Product.Amount = productLine.Amount;

            productLine.GroupName = this.group.GroupName;
            productLine.GroupType = this.group.GroupType;
            productLine.ForcingMultiplier = item.ForcingMultiplier;
            productLine.TotalPrice = item.SelectedPrice.Price * productLine.Amount;
            productLine.UnitPrice = item.SelectedPrice.Price;
            productLine.PriceLabel = item.SelectedPrice.Label;

            productLine.Parent = this.getParent();

            // Create passenger assignments.
            // if(item.ForcingMultiplier === 'PerPassenger'){
            //     var passengerAssignments = [];
            //     for(var i=0;i<add;i++){
            //         passengerAssignments.push({
            //             ProductNumber: item.SelectedPrice.Index, // Get product number from SelectedPrice Index.
            //             PassengerNumber: i // Passenger number is set by increasing number (from 0 to passenger count).
            //         });
            //     }
            //     productLine.PassengerAssignments = passengerAssignments;
            // }
            // Forced extra services are never assigned to passengers.
            // We don't have any way to see which passengers get which items, right?
            // We can't just randomly assign them to random passengers.
            // This will probably be implemented at some point, in a manner similar
            // to how buses work. For now, never assign to passengers at all.
            productLine.PassengerAssignments = null;

            // Select price and price label from item.SelectedPrice
            var priceSelections = [];
            priceSelections.push({
                Amount: productLine.Amount,
                PriceIndex: item.SelectedPrice.Index
            });
            productLine.PriceSelections = priceSelections;
        }

        // popup(message){
        //     this.$rootScope.$broadcast('popup-message', message);
        // }

    }, {
        key: 'isEqual',
        value: function isEqual(compare, to) {
            return JSON.stringify(compare) === JSON.stringify(to);
        }
    }, {
        key: 'getNumOfPeople',
        value: function getNumOfPeople() {
            return this.data.NumAdults + this.data.NumChildren;
        }
    }, {
        key: 'isCapacityFull',
        value: function isCapacityFull() {
            var _this6 = this;

            var groupProducts = _.filter(this.data.Products, function (product) {
                return product.GroupName === _this6.group.GroupName;
            });
            return _.sumBy(groupProducts, function (product) {
                return product.Amount;
            }) > this.getNumOfPeople();
        }
    }, {
        key: 'clone',
        value: function clone(product) {
            return JSON.parse(JSON.stringify(product));
        }
    }, {
        key: 'getNumOfPeople',
        value: function getNumOfPeople() {
            return this.data.NumAdults + this.data.NumChildren;
        }
    }, {
        key: 'createProductLineByProduct',
        value: function createProductLineByProduct(product) {
            var productLine = {
                Product: product,
                Amount: 0,
                PassengerAssignments: [],
                PriceSelections: [],
                UnitPrice: null,
                TotalPrice: null
            };
            this.data.Products.push(productLine);
            return productLine;
        }
    }, {
        key: 'findOrCreateProductLineByProductAndByPriceLabel',
        value: function findOrCreateProductLineByProductAndByPriceLabel(product) {
            var _this7 = this;

            var productLine = _.find(this.data.Products, function (productLine) {
                if (productLine.Product === null) {
                    return false;
                }
                return product.BeginDate === productLine.Product.BeginDate && product.EndDate === productLine.Product.EndDate && product.DestinationInfo.ProductCode === productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode === productLine.Product.DestinationInfo.DestinationCode && product.PriceLabel === productLine.PriceLabel && productLine.Parent && productLine.Parent.DestCode === _this7.searchProduct.DestinationInfo.DestinationCode && productLine.Parent.ProdCode === _this7.searchProduct.DestinationInfo.ProductCode;
            });

            if (!productLine) {
                // Create product line.
                productLine = this.createProductLineByProduct(product);
            }

            return productLine;
        }
    }, {
        key: 'findNormalProductLineInGroup',
        value: function findNormalProductLineInGroup(product) {
            return _.find(this.data.Products, function (productLine) {
                return productLine.GroupType === 'Normal' && productLine.GroupName === product.GroupName && productLine.PriceLabel === product.PriceLabel && productLine.Product.DestinationInfo.DestinationCode === product.Product.DestinationInfo.DestinationCode && productLine.Product.DestinationInfo.ProductName === product.Product.DestinationInfo.ProductName && productLine.Product.BeginDate === product.Product.BeginDate && productLine.Product.EndDate === product.Product.EndDate && productLine.Parent && productLine.Parent.DestCode === product.Parent.DestCode;
            });
        }
    }, {
        key: 'updateGroupBookingItem',
        value: function updateGroupBookingItem() {
            this.validate();
        }
    }, {
        key: 'updatePassengerAmountTitle',
        value: function updatePassengerAmountTitle() {
            this.passengerAmountTitle = this.getPassengerAmountTitle();
            this.passengerAmountTitle.params = this.getPassengerAmountTitleParams();
            this.validate();
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.group.GroupType !== 'GroupForced') return;

            var numOfPeople = this.getNumOfPeople();

            var errors = [];
            var params = {
                group: /*this.group.GroupName || 'Ryhmä' +*/this.group.GroupIdx + 1,
                num: numOfPeople

                // Accommodation exists from context.
            };if (this.group.hasMainProduct) {
                this.winresReservationContext.setReservationComponentErrors('extraservice_groups', 'extraservices_group_' + params.group, []);
                return;
            }

            // Too few and too many passengers error.
            if (_.some(this.group.Items, function (item) {
                return item.ForcingMultiplier === 'PerPassenger';
            })) {
                if (this.passengerAmount < numOfPeople) {
                    errors.push({
                        Message: 'reservation_extra_services.error_too_few_passenger_group',
                        Params: params
                    });
                }

                if (this.passengerAmount > numOfPeople) {
                    errors.push({
                        Message: 'reservation_extra_services.error_too_many_passenger_group',
                        Params: params
                    });
                }
            }

            // No group forced product selected error.
            if (_.some(this.group.Items, function (item) {
                return item.ForcingMultiplier === 'PerBooking';
            }) && !this.group.selectedItem) {
                errors.push({
                    Message: 'reservation_extra_services.error_too_few_booking_group',
                    Params: params
                });
            }

            this.winresReservationContext.setReservationComponentErrors('extraservice_groups', 'extraservices_group_' + params.group, errors);
        }
    }, {
        key: 'getPassengerAmountTitleParams',
        value: function getPassengerAmountTitleParams() {
            return {
                num: this.passengerAmount,
                max: this.getNumOfPeople(),
                left: this.getNumOfPeople() - this.passengerAmount
            };
        }
    }, {
        key: 'getPassengerAmountTitle',
        value: function getPassengerAmountTitle() {
            var numOfPeople = this.getNumOfPeople();

            if (this.passengerAmount < numOfPeople) return {
                text: 'reservation_extra_services.passenger_amount_too_few',
                color: '#234e86'
            };else if (this.passengerAmount === numOfPeople) return {
                text: 'reservation_extra_services.passenger_amount_enough',
                color: '#009900'
            };else return {
                text: 'reservation_extra_services.passenger_amount_too_many',
                color: '#f00'
            };
        }
    }]);

    return WinresReservationExtraServicesGroupController;
}();

WinresReservationExtraServicesGroupController.$inject = ['$rootScope', '$scope', '$timeout', '$filter'];

_module3.default.component('winresReservationExtraServicesGroup', {
    template: require('./winresReservationExtraServicesGroup.html'),
    controller: WinresReservationExtraServicesGroupController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        group: '<',
        searchProduct: '<',
        addForcedDelay: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationExtraServicesGroup/winresReservationExtraServicesGroup.js
// module id = 491
// module chunks = 2